import { DD_MM_YYYY } from "src/helpers";

export const calculateDaysDifference = (dateString?: string): number | undefined => {
  if (!dateString) return undefined;
  const date = new Date(dateString);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);
  const diffTime = today.getTime() - date.getTime();
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

const daysAgoSuffix = (daysDiff: number): string => {
  if (daysDiff === 0) return "Today";
  if (daysDiff === 1) return "1 day ago";
  return `${daysDiff} days ago`;
};

export const formatEstimatedDeliveryDate = (
  carrierEstimatedDeliveryDate?: string,
  confirmedEstDeliveryDate?: string,
  estimatedDeliveryDate?: string
): string | undefined => {
  if (carrierEstimatedDeliveryDate) {
    return `${DD_MM_YYYY.formatDate(new Date(carrierEstimatedDeliveryDate))}\u00A0(Tracking)`;
  }
  if (confirmedEstDeliveryDate) {
    return `${DD_MM_YYYY.formatDate(new Date(confirmedEstDeliveryDate))}\u00A0(Confirmed)`;
  }
  if (estimatedDeliveryDate) {
    return DD_MM_YYYY.formatDate(new Date(estimatedDeliveryDate));
  }
  return undefined;
};

export const formatActualDeliveryDate = (actualDeliveryDate?: string): string | undefined => {
  if (!actualDeliveryDate) return undefined;
  const daysDiff = calculateDaysDifference(actualDeliveryDate);
  const dateStr = DD_MM_YYYY.formatDate(new Date(actualDeliveryDate));
  if (daysDiff !== undefined) {
    return `${dateStr} (${daysAgoSuffix(daysDiff)})`;
  }
  return dateStr;
};

export const formatShipDate = (
  actualDeliveryDate?: string,
  carrierEstimatedDeliveryDate?: string,
  confirmedEstDeliveryDate?: string,
  estimatedDeliveryDate?: string
): string | undefined => {
  if (actualDeliveryDate) {
    return `${DD_MM_YYYY.formatDate(new Date(actualDeliveryDate))}\u00A0(Actual)`;
  }
  if (carrierEstimatedDeliveryDate) {
    return `${DD_MM_YYYY.formatDate(new Date(carrierEstimatedDeliveryDate))}\u00A0(Tracking)`;
  }
  if (confirmedEstDeliveryDate) {
    return `${DD_MM_YYYY.formatDate(new Date(confirmedEstDeliveryDate))}\u00A0(Confirmed)`;
  }
  if (estimatedDeliveryDate) {
    return DD_MM_YYYY.formatDate(new Date(estimatedDeliveryDate));
  }
  return undefined;
};

export const formatLastReceiptDate = (checkInTimestamps?: string[]): string => {
  if (!checkInTimestamps?.length) return "No receipts";
  const latest = checkInTimestamps.reduce((max, ts) => (ts > max ? ts : max));
  const dateStr = DD_MM_YYYY.formatDate(new Date(latest));
  const daysDiff = calculateDaysDifference(latest);
  if (dateStr && daysDiff !== undefined) {
    return `${dateStr} (${daysAgoSuffix(daysDiff)})`;
  }
  return dateStr ?? "No receipts";
};
